<template>
  <div class="bulkUpdate">
    <Toast position="top-right" />
    <navigation />

    <Toolbar class="p-mb-4 tool-bar-styling">
      <template slot="left">
        <Button label="Save" icon="pi pi-save" v-tooltip="'Click to save edited liabilities'" class="p-button-info p-mr-2" @click="saveUpdatedData" />
      </template>
    </Toolbar>

     <Toolbar class="p-mb-4 tool-bar-styling ">
      <template slot="left">
        <Dropdown @change="bulkUpdateDropdownOptionChanged" v-model="bulkUpdateDropdownSelectedValue" :options="liabilityChartColumnNames" optionLabel="name" optionValue="value" placeholder="Select a Column" class="liability-chart p-column-filter p-mr-2" :showClear="true"></Dropdown>
        <Dropdown v-if="displayBulkUpdateDropdown" v-model="bulkUpdateOptionValue" :options="bulkUpdateDropdownValues" optionLabel="name" optionValue="value" placeholder="Select a Column" class="liability-chart p-column-filter p-mr-2" :showClear="true"></Dropdown>
        <InputText class="p-mr-2" v-if="displayBulkUpdateInput" v-model="bulkUpdateOptionValue"/>
        <Button :disabled="!selectedLiabilities.length" label="Update" icon="pi pi-plus" v-tooltip="'Click to save edited liabilities'" class="p-button-info p-mr-2 button-custom" @click="handleBulkUpdateDropdownClick" />

      </template>
    </Toolbar>

    <DataTable :selection.sync="selectedLiabilities" v-if="isLoaded" :value="liabilityData" editMode="cell"  @cell-edit-complete="onCellEditComplete"  class="editable-cells-table bulk-update" :scrollable="true">
      <Column selectionMode="multiple" headerStyle="width: 3rem" :exportable="false"></Column>

      <Column field="id" header="Liability ID" headerStyle="width: 170px" :disabled="true">
        <template #editor="slotProps">
          <label for="id">{{slotProps.data[slotProps.column.field]}}</label>
        </template>
      </Column>

      <Column field="date_incurred" header="Date Incurred" headerStyle="width: 170px" :disabled="true">
        <template #editor="slotProps">
          <label for="date_incurred">{{slotProps.data[slotProps.column.field]}}</label>
        </template>
      </Column>

      <Column field="vendor" header="Vendor" headerStyle="width: 200px">
        <template #body="slotProps">
          <label for="date_incurred">{{slotProps.data[slotProps.column.field]}}</label>
        </template>
      </Column>
  
      <Column field="liability_reason" header="Liability Reason" headerStyle="width: 300px" >
        <template #editor="slotProps" v-if="isProductionTeamMember">
          <Dropdown v-model="slotProps.data[slotProps.column.field]" :options="liabilityReason" optionLabel="name" optionValue="name" placeholder="Select a Liability Reason">
            <template #option="slotProps">
              <span>{{slotProps.option.name}}</span>
            </template>
          </Dropdown>
        </template>
        <template #body="slotProps" v-else>
          <label>{{slotProps.data[slotProps.column.field]}}</label>
        </template>
      </Column>

      <Column field="status" header="Status" headerStyle="width: 220px">
        <template #editor="slotProps" v-if="isProductionTeamMember">
          <Dropdown v-model="slotProps.data[slotProps.column.field]" :options="liabilityStatus" optionLabel="name" optionValue="value" placeholder="Select Liability Status">
            <template #option="slotProps">
              <div class="p-dropdown-car-value" v-if="slotProps.value">
                <span>{{slotProps.value}}</span>
              </div>
              <span v-else>
                {{slotProps.placeholder}}
              </span>
            </template>
            <template #option="slotProps">
              <div>
                <span>{{slotProps.option.name}}</span>
              </div>
            </template>
          </Dropdown>
        </template>
        <template #body="slotProps" v-else>
          <label>{{slotProps.data[slotProps.column.field]}}</label>
        </template>
      </Column>

      <Column field="division" header="Division" headerStyle="width: 200px">
       <template #editor="slotProps" v-if="isProductionTeamMember || isFactoryTeamMember">
         <Dropdown :disabled="!isFactoryTeamMember && !isProductionTeamMember" v-model="slotProps.data[slotProps.column.field]" :options="divisionOptions" optionLabel="name" optionValue="value" placeholder="Select a Division">
              <template #value="slotProps">
                <div class="p-dropdown-car-value" v-if="slotProps.value">
                  <span>{{slotProps.value}}</span>
                </div>
                <span v-else>
                  {{slotProps.placeholder}}
                </span>
              </template>
              <template #option="slotProps">
                <div>
                  <span>{{slotProps.option.name}}</span>
                </div>
              </template>
            </Dropdown>
        </template>
        <template #body="slotProps" v-else>
          <label>{{slotProps.data[slotProps.column.field]}}</label>
        </template>
      </Column>

      <Column field="season_name" header="Season Name" headerStyle="width: 150px" :disabled="!isFactoryTeamMember">
        <template #editor="slotProps" v-if="isProductionTeamMember || isFactoryTeamMember">
          <Dropdown v-model="slotProps.data[slotProps.column.field]" :options="liabilitySeasonName" optionLabel="name" optionValue="value" placeholder="Select a Div">
            <template #option="slotProps">
              <div class="p-dropdown-car-value" v-if="slotProps.value">
                <span>{{slotProps.value}}</span>
              </div>
              <span v-else>
                {{slotProps.placeholder}}
              </span>
            </template>
            <template #option="slotProps">
              <div>
                <span>{{slotProps.option.name}}</span>
              </div>
            </template>
          </Dropdown>
        </template>
        <template #body="slotProps" v-else>
          <label>{{slotProps.data[slotProps.column.field]}}</label>
        </template>
      </Column>

      <Column field="season_year" header="Season Year*" headerStyle="width: 150px">
        <template #editor="slotProps" v-if="isProductionTeamMember || isFactoryTeamMember">
          <InputText v-model="slotProps.data[slotProps.column.field]" @input="onCellEdit($event, slotProps)"/>
           <small v-if="!slotProps.data[slotProps.column.field]" class="p-invalid">Season Year can't be empty</small>
        </template>
        <template #body="slotProps" v-else>
          <label>{{slotProps.data[slotProps.column.field]}}</label>
        </template>
      </Column>

      <Column field="supplier" header="Supplier *" headerStyle="width: 250px">
        <template #editor="slotProps" v-if="isProductionTeamMember || isFactoryTeamMember">
          <InputText v-model="slotProps.data[slotProps.column.field]" @input="onCellEdit($event, slotProps)"/>
           <small v-if="!slotProps.data[slotProps.column.field]" class="p-invalid">Supplier can't be empty</small>
        </template>
        <template #body="slotProps" v-else>
          <label>{{slotProps.data[slotProps.column.field]}}</label>
        </template>
      </Column>

      <Column field="collection" header="Collection *" headerStyle="width: 250px">
        <template #editor="slotProps" v-if="isProductionTeamMember || isFactoryTeamMember">
          <InputText v-model="slotProps.data[slotProps.column.field]" @input="onCellEdit($event, slotProps)"/>
           <small v-if="!slotProps.data[slotProps.column.field]" class="p-invalid">Collection can't be empty</small>
        </template>
        <template #body="slotProps" v-else>
          <label>{{slotProps.data[slotProps.column.field]}}</label>
        </template>
      </Column>

      <Column field="style" header="Style" headerStyle="width: 250px">
        <template #editor="slotProps" v-if="isProductionTeamMember || isFactoryTeamMember">
          <InputText v-model="slotProps.data[slotProps.column.field]"/>
        </template>
        <template #body="slotProps" v-else>
          <label>{{slotProps.data[slotProps.column.field]}}</label>
        </template>
      </Column>

      <Column field="style_description" header="Style Description" headerStyle="width: 350px">
        <template #editor="slotProps" v-if="isProductionTeamMember || isFactoryTeamMember">
          <Textarea  v-model.trim="slotProps.data[slotProps.column.field]" rows="6" cols="60" />
        </template>
        <template #body="slotProps" v-else>
          <label>{{slotProps.data[slotProps.column.field]}}</label>
        </template>
      </Column>

      <Column field="greige_or_dyed" header="Greige Or Dyed" headerStyle="width: 190px">
        <template #editor="slotProps" v-if="isProductionTeamMember || isFactoryTeamMember">
          <Dropdown v-model="slotProps.data[slotProps.column.field]" :options="liabilityColorPattern" optionLabel="name" optionValue="value" placeholder="Select a Div">
            <template #option="slotProps">
              <div class="p-dropdown-car-value" v-if="slotProps.value">
                <span>{{slotProps.value}}</span>
              </div>
              <span v-else>
                {{slotProps.placeholder}}
              </span>
            </template>
            <template #option="slotProps">
              <div>
                <span>{{slotProps.option.name}}</span>
              </div>
            </template>
          </Dropdown>
        </template>
        <template #body="slotProps" v-else>
          <label>{{slotProps.data[slotProps.column.field]}}</label>
        </template>
      </Column>

      <Column field="liability_location" header="Liability Location" headerStyle="width: 220px">
        <template #editor="slotProps" v-if="isProductionTeamMember || isFactoryTeamMember">
          <Dropdown v-model="slotProps.data[slotProps.column.field]" :options="liabilityLocation" optionLabel="name" optionValue="value" placeholder="Select a Div">
            <template #option="slotProps">
              <div class="p-dropdown-car-value" v-if="slotProps.value">
                <span>{{slotProps.value}}</span>
              </div>
              <span v-else>
                {{slotProps.placeholder}}
              </span>
            </template>
            <template #option="slotProps">
              <div>
                <span>{{slotProps.option.name}}</span>
              </div>
            </template>
          </Dropdown>
        </template>
        <template #body="slotProps" v-else>
          <label>{{slotProps.data[slotProps.column.field]}}</label>
        </template>
      </Column>

      <Column field="article" header="Article # *" headerStyle="width: 220px">
        <template #editor="slotProps" v-if="isProductionTeamMember || isFactoryTeamMember">
          <InputText v-model="slotProps.data[slotProps.column.field]" @input="onCellEdit($event, slotProps)"/>
           <small v-if="!slotProps.data[slotProps.column.field]" class="p-invalid">Article # can't be empty</small>
        </template>
        <template #body="slotProps" v-else>
          <label>{{slotProps.data[slotProps.column.field]}}</label>
        </template>
      </Column>

      <Column field="fabric_name_and_description" header="Fabric Name & Description" headerStyle="width: 350px">
        <template #editor="slotProps" v-if="isProductionTeamMember || isFactoryTeamMember">
          <Textarea  v-model.trim="slotProps.data[slotProps.column.field]" rows="6" cols="60" />
        </template>
        <template #body="slotProps" v-else>
          <label>{{slotProps.data[slotProps.column.field]}}</label>
        </template>
      </Column>

      <Column field="trim_description_and_article" header="Trim Description & Article" headerStyle="width: 300px">
        <template #editor="slotProps" v-if="isProductionTeamMember || isFactoryTeamMember">
          <Textarea  v-model.trim="slotProps.data[slotProps.column.field]" rows="6" cols="60" />
        </template>
        <template #body="slotProps" v-else>
          <label>{{slotProps.data[slotProps.column.field]}}</label>
        </template>
      </Column>

      <Column field="color" header="Color *" headerStyle="width: 210px">
        <template #editor="slotProps" v-if="isProductionTeamMember || isFactoryTeamMember">
          <InputText v-model="slotProps.data[slotProps.column.field]" @input="onCellEdit($event, slotProps)"/>
          <small v-if="!slotProps.data[slotProps.column.field]" class="p-invalid">Color can't be empty</small>
        </template>
        <template #body="slotProps" v-else>
          <label>{{slotProps.data[slotProps.column.field]}}</label>
        </template>
      </Column>

      <Column field="quantity" header="Quantity *" headerStyle="width: 190px" :disabled="!isFactoryTeamMember">
        <template #editor="slotProps" v-if="isFactoryTeamMember || isProductionTeamMember">
          <InputText v-model="slotProps.data[slotProps.column.field]" @input="onCellEdit($event, slotProps)"/>
           <small v-if="!slotProps.data[slotProps.column.field]" class="p-invalid">Quantity can't be empty</small>
        </template>
        <template #body="slotProps" v-else>
          <label>{{slotProps.data[slotProps.column.field]}}</label>
        </template>
      </Column>

      <Column field="uom" header="UOM" headerStyle="width: 170px">
        <template #editor="slotProps" v-if="isFactoryTeamMember || isProductionTeamMember">
          <Dropdown v-model="slotProps.data[slotProps.column.field]" :options="liabilityUOM" optionLabel="name" optionValue="value" placeholder="Select a Div">
            <template #option="slotProps">
              <div class="p-dropdown-car-value" v-if="slotProps.value">
                <span>{{slotProps.value}}</span>
              </div>
              <span v-else>
                {{slotProps.placeholder}}
              </span>
            </template>
            <template #option="slotProps">
              <div>
                <span>{{slotProps.option.name}}</span>
              </div>
            </template>
          </Dropdown>
        </template>
        <template #body="slotProps" v-else>
          <label>{{slotProps.data[slotProps.column.field]}}</label>
        </template>
      </Column>

      <Column field="fob_unit_cost" header="FOB Unit Cost *" headerStyle="width: 190px" :disabled="!isFactoryTeamMember">
        <template #editor="slotProps" v-if="isFactoryTeamMember || isProductionTeamMember">
          <InputText v-model="slotProps.data[slotProps.column.field]" @input="onCellEdit($event, slotProps)"/>
           <small v-if="!slotProps.data[slotProps.column.field]" class="p-invalid">FOB Unit Cost can't be empty</small>
        </template>
        <template #body="slotProps" v-else>
          <label>{{slotProps.data[slotProps.column.field]}}</label>
        </template>
      </Column>

      <Column field="shelf_life" header="Shelf Life *" headerStyle="width: 220px" :disabled="!isFactoryTeamMember">
        <template #editor="slotProps" v-if="isFactoryTeamMember || isProductionTeamMember">
          <InputText v-model="slotProps.data[slotProps.column.field]" @input="onCellEdit($event, slotProps)"/>
           <small v-if="!slotProps.data[slotProps.column.field]" class="p-invalid">Shelf Life can't be empty</small>
        </template>
        <template #body="slotProps" v-else>
          <label>{{slotProps.data[slotProps.column.field]}}</label>
        </template>
      </Column>

      <Column field="total_liability" header="Total Liability" headerStyle="width: 250px" :disabled="!isFactoryTeamMember">
        <template #body="slotProps">
          <label>{{slotProps.data[slotProps.column.field]}}</label>
        </template>
      </Column>

       <Column field="estimated_garment_units" header="Estimated Garment Units *" headerStyle="width: 300px">
        <template #editor="slotProps" v-if="isFactoryTeamMember || isProductionTeamMember">
          <InputText v-model="slotProps.data[slotProps.column.field]" @input="onCellEdit($event, slotProps)"/>
           <small v-if="!slotProps.data[slotProps.column.field]" class="p-invalid">Estimated Garment Units can't be empty</small>
        </template>
        <template #body="slotProps" v-else>
          <label>{{slotProps.data[slotProps.column.field]}}</label>
        </template>
      </Column>

      <Column field="deposit" header="Deposit" headerStyle="width: 200px">
        <template #editor="slotProps" v-if="isFactoryTeamMember || isProductionTeamMember">
          <Dropdown v-model="slotProps.data[slotProps.column.field]" :options="liabilityDeposit" optionLabel="name" optionValue="value" placeholder="Select a Div">
            <template #option="slotProps">
              <div class="p-dropdown-car-value" v-if="slotProps.value">
                <span>{{slotProps.value}}</span>
              </div>
              <span v-else>
                {{slotProps.placeholder}}
              </span>
            </template>
            <template #option="slotProps">
              <div>
                <span>{{slotProps.option.name}}</span>
              </div>
            </template>
          </Dropdown>
        </template>
        <template #body="slotProps" v-else>
          <label>{{slotProps.data[slotProps.column.field]}}</label>
        </template>
      </Column>

      <Column field="approved" header="Validated By Production" headerStyle="width: 200px">
        <template #editor="slotProps" v-if="isFactoryTeamMember || isProductionTeamMember">
          <Dropdown v-model="slotProps.data[slotProps.column.field]" :options="validatedOptions" optionLabel="name" optionValue="value" placeholder="Select if Validated">
            <template #option="slotProps">
              <div class="p-dropdown-car-value" v-if="slotProps.value">
                <span>{{slotProps.value}}</span>
              </div>
              <span v-else>
                {{slotProps.placeholder}}
              </span>
            </template>
            <template #option="slotProps">
              <div>
                <span>{{slotProps.option.name}}</span>
              </div>
            </template>
          </Dropdown>
        </template>
        <template #body="slotProps" v-else>
          <label>{{slotProps.data[slotProps.column.field]}}</label>
        </template>
      </Column>

      <Column field="po" header="PO # *" headerStyle="width: 200px">
        <template #editor="slotProps" v-if="isFactoryTeamMember || isProductionTeamMember">
          <InputText v-model="slotProps.data[slotProps.column.field]" @input="onCellEdit($event, slotProps)"/>
           <small v-if="!slotProps.data[slotProps.column.field]" class="p-invalid">PO # can't be empty</small>
        </template>
        <template #body="slotProps" v-else>
          <label>{{slotProps.data[slotProps.column.field]}}</label>
        </template>
      </Column>

      <Column field="date_invoice_received" header="Date Invoice Received" headerStyle="width: 250px">
        <template #editor="slotProps" v-if="isFinanceTeamMember || isProductionTeamMember">
          <InputText v-model="slotProps.data[slotProps.column.field]" placeholder="MM-DD-YYYY"/>
        </template>
        <template #body="slotProps" v-else>
          <label>{{slotProps.data[slotProps.column.field]}}</label>
        </template>
      </Column>

      <Column field="invoice" header="Invoice #" headerStyle="width: 250px">
        <template #editor="slotProps" v-if="isFinanceTeamMember || isProductionTeamMember">
          <InputText v-model="slotProps.data[slotProps.column.field]"/>
        </template>
        <template #body="slotProps" v-else>
          <label>{{slotProps.data[slotProps.column.field]}}</label>
        </template>
      </Column>

      <Column field="initial_approver_for_invoice_payment" header="Initial Approver for Invoice Payment" headerStyle="width: 300px">
        <template #editor="slotProps" v-if="isFinanceTeamMember || isProductionTeamMember">
          <Dropdown v-model="slotProps.data[slotProps.column.field]" :options="liabilityInvoiceApprover" optionLabel="name" optionValue="value" placeholder="Select a Div">
            <template #option="slotProps">
              <div class="p-dropdown-car-value" v-if="slotProps.value">
                <span>{{slotProps.value}}</span>
              </div>
              <span v-else>
                {{slotProps.placeholder}}
              </span>
            </template>
            <template #option="slotProps">
              <div>
                <span>{{slotProps.option.name}}</span>
              </div>
            </template>
          </Dropdown>
        </template>
        <template #body="slotProps" v-else>
          <label>{{slotProps.data[slotProps.column.field]}}</label>
        </template>
      </Column>

      <Column field="final_approver_for_invoice_payment" header="Final Approver for Invoice Payment" headerStyle="width: 300px">
        <template #editor="slotProps" v-if="isFinanceTeamMember || isProductionTeamMember">
          <InputText v-model="slotProps.data[slotProps.column.field]"/>
        </template>
        <template #body="slotProps" v-else>
          <label>{{slotProps.data[slotProps.column.field]}}</label>
        </template>
      </Column>

      <Column field="date_invoice_paid" header="Date Invoice Paid" headerStyle="width: 180px">
        <template #editor="slotProps" v-if="isFinanceTeamMember || isProductionTeamMember">
          <InputText v-model="slotProps.data[slotProps.column.field]" placeholder="MM-DD-YYYY"/>
        </template>
        <template #body="slotProps" v-else>
          <label>{{slotProps.data[slotProps.column.field]}}</label>
        </template>
      </Column>

      <Column field="original_units" header="Original Units *" headerStyle="width: 200px">
        <template #editor="slotProps" v-if="isFactoryTeamMember || isProductionTeamMember">
          <InputText v-model="slotProps.data[slotProps.column.field]" @input="onCellEdit($event, slotProps)"/>
           <small v-if="!slotProps.data[slotProps.column.field]" class="p-invalid">Original Units can't be empty</small>
        </template>
        <template #body="slotProps" v-else>
          <label>{{slotProps.data[slotProps.column.field]}}</label>
        </template>
      </Column>

      <Column field="original_total_liability" header="Original Total Liability *" headerStyle="width: 250px">
        <template #editor="slotProps" v-if="isFactoryTeamMember || isProductionTeamMember">
          <InputText v-model="slotProps.data[slotProps.column.field]" @input="onCellEdit($event, slotProps)"/>
           <small v-if="!slotProps.data[slotProps.column.field]" class="p-invalid">Original Total Liability can't be empty</small>
        </template>
        <template #body="slotProps" v-else>
          <label>{{slotProps.data[slotProps.column.field]}}</label>
        </template>
      </Column>

      <Column field="date_closed" header="Date Closed" headerStyle="width: 180px">
        <template #body="slotProps">
          <label>{{slotProps.data[slotProps.column.field]}}</label>
        </template>
      </Column>

      <Column field="closed" header="Closed" headerStyle="width: 180px">
        <template #editor="slotProps" v-if="isProductionTeamMember">
          <Dropdown v-model="slotProps.data[slotProps.column.field]" @change="liabilityClosedStatusChanged(slotProps)" :options="liabilityClosedStatus" optionLabel="name" optionValue="value" placeholder="Select a Status">
            <template #option="slotProps">
              <div class="p-dropdown-car-value" v-if="slotProps.value">
                <span>{{slotProps.value}}</span>
              </div>
              <span v-else>
                {{slotProps.placeholder}}
              </span>
            </template>
            <template #option="slotProps">
              <div>
                <span>{{slotProps.option.name}}</span>
              </div>
            </template>
          </Dropdown>
        </template>
        <template #body="slotProps" v-else>
          <label>{{slotProps.data[slotProps.column.field]}}</label>
        </template>
      </Column>
    </DataTable>
  </div>
</template>

<script>
  import navigation from "../../components/helperComponents/menu";
  import DataTable from "primevue/datatable";
  import Column from "primevue/column";
  import InputText from "primevue/inputtext";
  import Toolbar from "primevue/toolbar";
  import http from "../../http-common";
  import Dropdown from "primevue/dropdown";
  import Button from "primevue/button";
  import Textarea from 'primevue/textarea';
  import Tooltip from 'primevue/tooltip';
  import Toast from 'primevue/toast';

  export default {
    name: 'BulkUpdteLiability',
    components: {
      Textarea,
      DataTable,
      Column,
      navigation,
      InputText,
      Toolbar,
      Dropdown,
      Button,
      Toast,
    },
    directives: {
      'tooltip': Tooltip
    },
    props: {
      liabilityRowIDs: Array
    },
    data() {
      return {
        displayBulkUpdateDropdown: false,
        displayBulkUpdateInput: false,
        liabilityData: [],
        isLoaded: false,
        selectedLiabilities: [],
        bulkUpdateDropdownSelectedValue: null,
        isFactoryTeamMember: false,
        isProductionTeamMember: false,
        isFinanceTeamMember: false,
        editingCellRows: {},
        userInfo: {},
        isFilledData: true,
        isValidNumber: true,
        isDateValid: true,
        apiUrlPath: 'api/master-liability-chart',
        clonedElement: {},
        bulkUpdateOptionValue: null,
        bulkUpdateTextValue: null,
        currentDate: new Date().getMonth() > 8 ? (new Date().getMonth() + 1) : ('0' + (new Date().getMonth() + 1)) + '-' + ((new Date().getDate() > 9) ? new Date().getDate() : ('0' + new Date().getDate())) + '-' + new Date().getFullYear(),
        liabilityStatus: [
          {name: 'CHECK WITH VENDOR', value: 'CHECK WITH VENDOR'},
          {name: 'NEED USAGE PLAN', value: 'NEED USAGE PLAN'},
          {name: 'INVOICE RECEIVED', value: 'INVOICE RECEIVED'},
          {name: 'PAID AS ADVANCE INTEND TO USE', value: 'PAID AS ADVANCE INTEND TO USE'},
          {name: 'EXPIRED / NEED TO SETTLE', value: 'EXPIRED / NEED TO SETTLE'},
          {name: 'LIABILITY USED/ CLOSED', value: 'LIABILITY USED/ CLOSED'},
          {name: 'VENDORS LIABILITY', value: 'VENDORS LIABILITY'},
          {name: 'CONFIRMED TO WRITE OFF', value: 'CONFIRMED TO WRITE OFF'},
        ],
        liabilitySeasonName: [
          {name: 'Fall', value: 'Fall'},
          {name: 'Holiday', value: 'Holiday'},
          {name: 'Spring', value: 'Spring'},
          {name: 'Summer', value: 'Summer'},
          {name: 'Basic', value: 'Basic'}
        ],
        liabilityColorPattern: [
          {name: 'Greige', value: 'Greige'},
          {name: 'Dye', value: 'Dye'},
          {name: 'Not Applicable', value: 'Not Applicable'},
        ],
        liabilityLocation: [
          {name: 'Factory', value: 'Factory'},
          {name: 'Mill', value: 'Mill'}
        ],
        liabilityUOM: [
          {name: 'PCS', value: 'PCS'},
          {name: 'UNITS', value: 'UNITS'},
          {name: 'YDS', value: 'YDS'},
          {name: 'MTRS', value: 'MTRS'},
          {name: 'CONES', value: 'CONES'},
          {name: 'EACH', value: 'EACH'},
          {name: 'SET', value: 'SET'},
        ],
        liabilityDeposit: [
          {name: 'Yes', value: 'Yes'},
          {name: 'No', value: 'No'}
        ],
        liabilityInvoiceApprover: [
          {name: 'Design', value: 'Design'},
          {name: 'Merch', value: 'Merch'},
          {name: 'Marketing', value: 'Marketing'},
          {name: 'ELT', value: 'ELT'}
        ],
        liabilityClosedStatus: [
          {name: 'Yes', value: 'Yes'},
          {name: 'No', value: 'No'}
        ],
        validatedOptions: [
          {name: 'Yes', value: 'Yes'},
          {name: 'No', value: 'No'}
        ],
        liabilityReason: [
          {name: 'Production (Change allocation)', value: 'Production (Change allocation)'},
          {name: 'Planning/Merch (Cancelled PO/Reduced Units/MOQ/Asst Changes)', value: 'Planning/Merch (Cancelled PO/Reduced Units/MOQ/Asst Changes)'},
          {name: 'Design (Product Change/Fit Change)', value: 'Design (Product Change/Fit Change)'},
          {name: 'Marketing (GWP)', value: 'Marketing (GWP)'},
          {name: 'ELT decision', value: 'ELT decision'},
          {name: 'Contingency', value: 'Contingency'},
          {name: 'Used or Destroy', value: 'Used or Destroy'},
        ],
        divisionOptions: [
          {name: 'Men', value: 'Men'},
          {name: 'Women', value: 'Women'},
          {name: 'Not Applicable', value: 'Not Applicable'},
        ],
        liabilityChartColumnNames: [
          {name: 'Liability Reason', value: 'liability_reason'},
          {name: 'Status', value: 'status'},
          {name: 'Division', value: 'division'},
          {name: 'Season Name', value: 'season_name'},
          {name: 'Season Year', value: 'season_year'},
          {name: 'Supplier', value: 'supplier'},
          {name: 'Collection', value: 'collection'},
          {name: 'Style', value: 'style'},
          {name: 'Style Description', value: 'style_description'},
          {name: 'Greige Or Dyed', value: 'greige_or_dyed'},
          {name: 'Liability Location', value: 'liability_location'},
          {name: 'Article #', value: 'article'},
          {name: 'Fabric Name & Description', value: 'fabric_name_and_description'},
          {name: 'Trim Description & Article', value: 'trim_description_and_article'},
          {name: 'Validated By Production', value: 'approved'},
          {name: 'Quantity', value: 'quantity'},
          {name: 'UOM', value: 'uom'},
          {name: 'Fob Unit Cost', value: 'fob_unit_cost'},
          {name: 'Shelf Life', value: 'shelf_life'},
          {name: 'Estimated Garment Units', value: 'estimated_garment_units'},
          {name: 'Deposit', value: 'deposit'},
          {name: 'PO #', value: 'po'},
          {name: 'Date Invoice Received', value: 'date_invoice_received'},
          {name: 'Color', value: 'color'}, 
          {name: 'Invoice', value: 'invoice'},
          {name: 'Initial Approver for Invoice Payment', value: 'initial_approver_for_invoice_payment'},
          {name: 'Final Approver for Invoice Payment', value: 'final_approver_for_invoice_payment'},
          {name: 'Date Invoice Paid', value: 'date_invoice_paid'},
          {name: 'Original Units', value: 'original_units'},
          {name: 'Original Total Liability', value: 'original_total_liability'},
          {name: 'Closed Status', value: 'closed'}
        ]
      };
    },
    methods: {
      bulkUpdateDropdownOptionChanged () {
        if (this.bulkUpdateDropdownSelectedValue == "status" || this.bulkUpdateDropdownSelectedValue == "season_name" ||
        this.bulkUpdateDropdownSelectedValue == "greige_or_dyed" || this.bulkUpdateDropdownSelectedValue == "liability_reason" || this.bulkUpdateDropdownSelectedValue == "liability_location" ||
        this.bulkUpdateDropdownSelectedValue == "uom" || this.bulkUpdateDropdownSelectedValue == "deposit" || 
        this.bulkUpdateDropdownSelectedValue == "initial_approver_for_invoice_payment" || this.bulkUpdateDropdownSelectedValue == "closed" || this.bulkUpdateDropdownSelectedValue == "division" || this.bulkUpdateDropdownSelectedValue == "approved") {
          if (this.bulkUpdateDropdownSelectedValue == "status") {
            this.bulkUpdateDropdownValues = this.liabilityStatus;
          } else if (this.bulkUpdateDropdownSelectedValue == "season_name") {
            this.bulkUpdateDropdownValues = this.liabilitySeasonName;
          } else if (this.bulkUpdateDropdownSelectedValue == "greige_or_dyed") {
            this.bulkUpdateDropdownValues = this.liabilityColorPattern;
          } else if (this.bulkUpdateDropdownSelectedValue == "liability_location") {
            this.bulkUpdateDropdownValues = this.liabilityLocation;
          } else if (this.bulkUpdateDropdownSelectedValue == "uom") {
            this.bulkUpdateDropdownValues = this.liabilityUOM;
          } else if (this.bulkUpdateDropdownSelectedValue == "deposit") {
            this.bulkUpdateDropdownValues = this.liabilityDeposit;
          } else if (this.bulkUpdateDropdownSelectedValue == "initial_approver_for_invoice_payment") {
            this.bulkUpdateDropdownValues = this.liabilityInvoiceApprover;
          } else if (this.bulkUpdateDropdownSelectedValue == "closed") {
            this.bulkUpdateDropdownValues = this.liabilityClosedStatus;
          } else if (this.bulkUpdateDropdownSelectedValue == "liability_reason") {
            this.bulkUpdateDropdownValues = this.liabilityReason;
          } else if (this.bulkUpdateDropdownSelectedValue == "division") {
            this.bulkUpdateDropdownValues = this.divisionOptions;
          } else if (this.bulkUpdateDropdownSelectedValue == "approved") {
            this.bulkUpdateDropdownValues = this.validatedOptions;
          }
          this.displayBulkUpdateDropdown = true;
          this.displayBulkUpdateInput = false;
        } else if (this.bulkUpdateDropdownSelectedValue == "color" || this.bulkUpdateDropdownSelectedValue == "season_year" || this.bulkUpdateDropdownSelectedValue == "supplier" ||
        this.bulkUpdateDropdownSelectedValue == "style_description" || this.bulkUpdateDropdownSelectedValue == "style" || this.bulkUpdateDropdownSelectedValue == "article" || 
        this.bulkUpdateDropdownSelectedValue == "fabric_name_and_description" || this.bulkUpdateDropdownSelectedValue == "trim_description_and_article" || 
        this.bulkUpdateDropdownSelectedValue == "quantity" || this.bulkUpdateDropdownSelectedValue == "fob_unit_cost" || 
        this.bulkUpdateDropdownSelectedValue == "shelf_life" || this.bulkUpdateDropdownSelectedValue == "total_liability" ||
        this.bulkUpdateDropdownSelectedValue == "estimated_garment_units" || this.bulkUpdateDropdownSelectedValue == "date_closed" ||  this.bulkUpdateDropdownSelectedValue == "po" || 
        this.bulkUpdateDropdownSelectedValue == "date_invoice_received" || this.bulkUpdateDropdownSelectedValue == "closed" || 
        this.bulkUpdateDropdownSelectedValue == "invoice" || this.bulkUpdateDropdownSelectedValue == "final_approver_for_invoice_payment" || 
        this.bulkUpdateDropdownSelectedValue == "date_invoice_paid" || this.bulkUpdateDropdownSelectedValue == "original_units" || 
        this.bulkUpdateDropdownSelectedValue == "original_total_liability" || this.bulkUpdateDropdownSelectedValue == "collection") {
          this.displayBulkUpdateDropdown = false;
          this.displayBulkUpdateInput = true;
        } 
        this.bulkUpdateOptionValue = null;
      },
      saveUpdatedData (event) {
        let dateRegex = /^(0[1-9]|1[0-2])\-(0[1-9]|1\d|2\d|3[01])\-(19|20)\d{2}$/ ;
        this.isFilledData = true;
        this.isValidNumber = true;
        this.isDateValid = true;
        for(let i = 0; i < this.liabilityData.length; i++) {
          if (!this.liabilityData[i].season_year || !this.liabilityData[i].supplier || !this.liabilityData[i].collection || !this.liabilityData[i].article || !this.liabilityData[i].color || !this.liabilityData[i].quantity || !this.liabilityData[i].fob_unit_cost || !this.liabilityData[i].shelf_life || !this.liabilityData[i].estimated_garment_units || !this.liabilityData[i].po || !this.liabilityData[i].original_units || !this.liabilityData[i].original_total_liability || !this.liabilityData[i].collection) {
            this.isFilledData = false;
          }
          this.liabilityData[i].total_liability = this.liabilityData[i].quantity * this.liabilityData[i].fob_unit_cost;
          if(this.liabilityData[i].season_year == "" || this.liabilityData[i].supplier == "" || this.liabilityData[i].collection == "" || this.liabilityData[i].article == "" || this.liabilityData[i].color == "" || this.liabilityData[i].quantity == "" || this.liabilityData[i].fob_unit_cost == "" || this.liabilityData[i].shelf_life == "" || this.liabilityData[i].estimated_garment_units == "" || this.liabilityData[i].po == "" || this.liabilityData[i].original_units == "" || this.liabilityData[i].original_total_liability == "") {
            this.isFilledData = false;
          }
          if(!(/^\d+$/.test(this.liabilityData[i].season_year))) {
            this.isValidNumber = false;
          }
          if(!(/^\d+$/.test(this.liabilityData[i].quantity))) {
            this.isValidNumber = false;
          }
          if(!(dateRegex.test(this.liabilityData[i].date_invoice_paid)) && this.liabilityData[i].date_invoice_paid) {
            this.isDateValid = false;
          }
          if(!(dateRegex.test(this.liabilityData[i].shelf_life)) && this.liabilityData[i].shelf_life) {
            this.isDateValid = false;
          }
          if(!(dateRegex.test(this.liabilityData[i].date_invoice_received)) && this.liabilityData[i].date_invoice_received) {
            this.isDateValid = false;
          }
        }
        if(this.isFilledData) {
          if(this.isValidNumber && this.isDateValid) {
            this.clonedElement.updated = this.liabilityData;
            http.put(`${this.apiUrlPath}/bulk-update-liability`, this.clonedElement).then((response) => {
              if (response.status == 200) {
                this.$toast.add({severity:'success', summary: 'Successful', detail: 'Liabilities Updated', life: 3000});
              }
            })
            .catch((e) => {
              console.log(e);
            });
          } else {
            this.$toast.add({severity:'error', summary: 'Error', detail: "Year and Quantity should be numbers only. Date should be in MM-DD-YYYY format", life: 3000});
          }
        } else {
          this.$toast.add({severity:'error', summary: 'Error', detail: "Records with * can not be left blank", life: 3000});
        }
      },
      onCellEdit(newValue, props) {
        if (!this.editingCellRows[props.index]) {
          this.editingCellRows[props.index] = {...props.data};
        }

        this.editingCellRows[props.index][props.column.field] = newValue;
      },
          
      handleBulkUpdateDropdownClick () {
        let selectedIdsArray = this.selectedLiabilities.map((e) => e.id);
        this.liabilityData.forEach(element => {
        if (selectedIdsArray.includes(element.id)) {
          element[this.bulkUpdateDropdownSelectedValue] = this.bulkUpdateOptionValue;
          if(this.bulkUpdateDropdownSelectedValue == 'closed' && this.bulkUpdateOptionValue == "Yes") {
            element['date_closed'] = this.currentDate;
          } else {
            element['date_closed'] = null;
          }
        }
      }); 
    },
    
    getLiabilityDetailsByID () {
      let liabilityIDs;
      this.liabilityRowIDs ? liabilityIDs = this.liabilityRowIDs : liabilityIDs = sessionStorage.getItem("liabilityID");

      http
        .get(`${this.apiUrlPath}/master-liability-details-by-id/${liabilityIDs}`)
        .then((response) => {
          this.liabilityData = response.data; // JSON are parsed automatically.
          this.isLoaded = true;
        })
        .catch((e) => {
          console.log(e);
        });

        http
        .get(`${this.apiUrlPath}/master-liability-details-by-id/${liabilityIDs}`)
        .then((response) => {
          this.clonedElement.copy = response.data;
          this.clonedElement.userInfo = JSON.parse(sessionStorage.getItem("User Information"));
        })
        .catch((e) => {
          console.log(e);
        });
    },

      onCellEditComplete(event) {
        
        if (!this.editingCellRows[event.index]) {
          return;
        }

        const editingCellValue = this.editingCellRows[event.index][event.field];
        
        switch (event.field) {
          case '':
          default:
            if (editingCellValue.trim().length == 0)
              event.preventDefault();
            break;
          }
      },
      liabilityClosedStatusChanged (slotProps) {
        if (slotProps.data.closed == 'Yes') {
          this.liabilityData[slotProps.index].date_closed = this.currentDate;
        } else {
          this.liabilityData[slotProps.index].date_closed = null;
        }
        
      },
    },
    mounted () {
      this.getLiabilityDetailsByID();
      if (sessionStorage.getItem("User Information")) {
        this.userInfo = JSON.parse(sessionStorage.getItem("User Information"));
        this.vendorName = this.userInfo.vendor_name;
        if (this.userInfo.team == "Factory Team") {
          this.isFactoryTeamMember = true;
        } else if (this.userInfo.team == "Production Team") {
          this.isProductionTeamMember = true;
        } else if (this.userInfo.team == "Finance Team") {
          this.isFinanceTeamMember = true;
        }
      }
    }
  };
</script>

<style>
  .bulk-update .p-dropdown {
    width: 100%;
  }
  .button-custom {
    min-width: 100px;
  }
  .bulkUpdate.p-button.button-custom {
    overflow: unset;
  }
  .bulkUpdate .p-datatable-scrollable-body, .p-datatable-scrollable-header {
    overflow: visible !important;
  }

  .bulkUpdate .p-datatable-scrollable-view .p-datatable-scrollable-body {
    overflow: visible !important;
  }
</style>